import React from 'react';

import { Helmet } from 'react-helmet';
import Paper from '@mui/material/Paper';

import NotesList  from 'src/component/UI/NotesList';
import FilterBar from 'src/component/UI/FilterBar';
import { fetchNotes } from 'src/module/note/action';
import { getNotes, getLoadingNotes, getNumNotesPages, getTotalNotes } from 'src/module/note/selector';
import { isWhitelabel } from 'src/utils/utils';
import { useTranslation } from 'src/i18n';

export default function NoteScreen () {
  const { t } = useTranslation();
  const selectors = {
    getNotes: getNotes,
    getLoadingNotes: getLoadingNotes,
    getNumNotesPages: getNumNotesPages,
    getTotalNotes: getTotalNotes
  };

  const title = isWhitelabel() ? 'ATCOM' : 'SmartTrace';

  return (
    <div className='page' id='loto-screen'>
      <Helmet>
        <title>{title} - {t('notes.title')}</title>
      </Helmet>
      <FilterBar includeGrid />
      <br />
      <Paper>
        <NotesList
          noteType={'note'}
          selectors={selectors}
          showSubject
          showExpiry
          showAddNoteButton
          showSearchBar
          showArchivedOption
          showDeleteIcon
          fetch={fetchNotes}
        />
      </Paper>
    </div>
  );
}
